/**
 * Side Cart Wrapper Component
 * 
 * Wrapper that connects SideCart to the cart context.
 * Handles checkout navigation.
 */

'use client';

import { useCartContext } from '@/lib/context/cart-context';
import { env } from '@/lib/utils/env';
import { trackCheckoutStarted } from '@/lib/analytics';
import { resolveRuntimeAppUrl } from '@/lib/utils/runtime-app-url';
import { SideCart } from './SideCart';
import { FunnelCartBanner } from './FunnelCartBanner';

export function SideCartWrapper() {
  const { cartToken, setCartToken, isCartOpen, hideCart, clearCart } = useCartContext();

  const handleCheckout = (token: string) => {
    hideCart();
    trackCheckoutStarted({ cartToken: token });
    window.location.href = resolveRuntimeAppUrl(`${env.CHECKOUT_URL}/checkout/${token}`);
  };

  const handleCartUpdate = (newToken: string) => {
    if (newToken !== cartToken) {
      setCartToken(newToken);
    }
  };

  return (
    <SideCart
      cartToken={cartToken}
      isOpen={isCartOpen}
      onClose={hideCart}
      onCheckout={handleCheckout}
      onCartUpdate={handleCartUpdate}
      onCartCompleted={clearCart}
      summaryVariant="credits-bar"
      slots={{
        topBanner: <FunnelCartBanner />,
      }}
    />
  );
}
